/* eslint-disable no-nested-ternary */
import _ from 'lodash';
import moment from 'moment';
import Router from 'next/router';
import PropTypes from 'prop-types';

import useResponsive from '../../../utils/responsive';

import { Image, FadeInAnimation } from '../shared';

const BlogPageFeatured = (props) => {
    const { data } = props;
    const { isMobile, isTablet } = useResponsive();
    const imgSrc = data[0].acf.featured_image;
    const imgAlt = data[0].acf.featured_image_alt_text;
    const title = data[0].acf.seo_title;
    const summary = data[0].acf.meta_data_summary;
    const tags = data[0].acf.meta_data_tags;
    const published = data[0].acf.meta_data_publish_date;
    const slug = data[0].acf.url_slug;

    const onArticleClick = () => {
        Router.push(`blog/posts/${slug}`);
    };

    const checkForTags = () => {

        return _.map(tags, (tag, index) => {

            const type = _.toUpper(_.get(tag, 'tag'));

            return (

                <span className='blog-page-featured-span-left blog-page-featured-span' key={index}>

                    {type}

                </span>
            );

        });

    };

    return (

        <div className='blog-page-featured-container'>

            <FadeInAnimation>

                <Image
                    src={imgSrc}
                    alt={imgAlt}
                    width="100%"
                    height={isMobile ? 400 : isTablet ? 600 : 900}
                    className="card-image blog-page-featured-card-image"
                    isOldImage
                />

            </FadeInAnimation>

            <div className='blog-page-featured-flex-container'>

                <div className='blog-page-featured-card-container' onClick={onArticleClick}>

                    <p className='blog-page-featured-featured-text'>FEATURED</p>

                    <h3 className='blog-page-featured-featured-title'>{title}</h3>

                    <p className='blog-page-featured-featured-paragraph'>{summary}</p>

                    <div className='blog-page-featured-caption-container'>

                        {checkForTags()}

                        <span className='blog-page-featured-span-right blog-page-featured-span'>

                            {_.toUpper(moment(published).format('DD MMMM YYYY'))}

                        </span>

                    </div>

                </div>

            </div>

        </div>
        
    );
};

export default BlogPageFeatured;

BlogPageFeatured.propTypes = {
    data: PropTypes.array,
};

